

<div class="loader-backdrop" *ngIf="loading$ | async">
  <div class="loader-box">
    <img src="../../../assets/img/snatchit_logo.png" class="logo" />
    <div class="text">{{ message$ | async }}</div>
  </div>
</div>
